export const GLOBAL_COUNTRY_PERMISSION = 'ALL'
export const NO_REGION = ''

export interface Country {
  isoCode: string
  name: string
}

export interface AccessCountries {
  [key: string]: Country[]
}
